module.exports = __webpack_public_path__ + "img/gbx.39e91193.svg";